/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import GraderInstructions from 'bundles/grading/components/staff-graded-assignments/top-bar/GraderInstructions';
import LastSavedStatus from 'bundles/grading/components/staff-graded-assignments/top-bar/LastSavedStatus';
import MoreActions from 'bundles/grading/components/staff-graded-assignments/top-bar/MoreActions';

const styles = {
  container: () => css`
    display: flex;
    align-items: center;
  `,
  iconContainer: () => css`
    margin: 0 var(--cds-spacing-400);
  `,
};

// Component for SGA top bar right justified controls
const RightControls = () => {
  return (
    <div css={styles.container}>
      <LastSavedStatus />
      <GraderInstructions />
      <MoreActions />
    </div>
  );
};

export default RightControls;
